var render = function render(){var _vm=this,_c=_vm._self._c;return _c('unread-message-list',{attrs:{"messages":_vm.messages},on:{"close":_vm.closeFullView}})
}
var staticRenderFns = []

export { render, staticRenderFns }